module.exports = __webpack_public_path__ + "static/img/image_solutions_intellgent_05.19cafca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_intellgent_05.png
// module id = 1gOI
// module chunks = 10